module.exports = __webpack_public_path__ + "img/energy_nengxiao.95546c7d.png";